import React, { useState, useEffect } from 'react';
import { LinearProgress, CircularProgress } from '@mui/material';
import { AudioFile, ImageOutlined, PlayArrow, VideocamOutlined } from '@mui/icons-material';
import { S3_LESSONS } from 'Constants/General';
import { colors } from 'Constants/Colors';
import { s3 } from 'Services/AWS/s3';

import {
  CardContainer,
  ThumbnailContainer,
  ProgressContainer,
  LessonInfo,
  LessonTypeContainer,
  lessonTitle,
  lessonType,
  thumbnailImage,
  noImageIcon,
  videoIcon,
} from './style';
export default function LessonCard({ lesson, moduleId, clickEvent = () => {} }) {
  const [isLoading, setIsLoading] = useState(true);
  const [fetchedImage, setFetchedImage] = useState(null);

  // Generate the key for S3 bucket
  const thumbnailKey = `${S3_LESSONS}/${moduleId}/${lesson?.id}`;

  const lessonTypeName = (lesson?.LessonType?.name[0].toUpperCase() || 0) + (lesson?.LessonType?.name.slice(1) || 0);
  let imageContent;

  useEffect(() => {
    if (!fetchedImage && isLoading) {
      // Get the signed URL from S3
      s3.getSignedUrl(thumbnailKey)
        .then(imageUrl => {
          if (imageUrl) {
            setFetchedImage(imageUrl?.signedUrl);
            return;
          }

          setFetchedImage(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  if (isLoading) {
    imageContent = <CircularProgress color="MexlogGreen" />;
  }

  if (fetchedImage === false) {
    imageContent = <VideocamOutlined fontSize="large" style={noImageIcon} />;
  }

  if (fetchedImage !== false && !isLoading) {
    imageContent = (
      <video src={fetchedImage} style={thumbnailImage}>
        <source src={fetchedImage} type="video/mp4" />
      </video>
    );
  }

  return (
    <CardContainer onClick={clickEvent}>
      <ThumbnailContainer>
        {lesson?.LessonType?.name === 'video' ? imageContent : <AudioFile fontSize="large" style={noImageIcon} />}
        <ProgressContainer>
          <LinearProgress
            variant="determinate"
            value={lesson?.progress || 100}
            sx={{
              '& .MuiLinearProgress-barColorPrimary': {
                backgroundColor: colors.GREEN_SHINING_ULTRA,
              },
            }}
          />
        </ProgressContainer>
      </ThumbnailContainer>
      <LessonInfo>
        <div style={lessonTitle}>{lesson.name}</div>
        <LessonTypeContainer>
          <PlayArrow style={videoIcon} />
          <div style={lessonType}>{lessonTypeName}</div>
        </LessonTypeContainer>
      </LessonInfo>
    </CardContainer>
  );
}
